import { render, staticRenderFns } from "./AppointmentsAdmin.vue?vue&type=template&id=9737849e&"
import script from "./AppointmentsAdmin.vue?vue&type=script&lang=js&"
export * from "./AppointmentsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports